import {createSlice} from "@reduxjs/toolkit";

const initialConversionRatesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  conversionRateForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const conversionRatesSlice = createSlice({
  name: "conversionRates",
  initialState: initialConversionRatesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getConversionRateById
    conversionRateFetched: (state, action) => {
      state.actionsLoading = false;
      state.conversionRateForEdit = action.payload.conversionRateForEdit;
      state.error = null;
    },
    // findConversionRates
    conversionRatesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createConversionRate
    conversionRateCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      if(action.payload.conversionRate !== null){
        var usr = action.payload.conversionRate;
        state.entities.push(usr);
      }
    },
    // updateConversionRate
    conversionRateUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.conversionRate.id) {
          return action.payload.conversionRate;
        }
        return entity;
      });
    },
    // deleteConversionRate
    conversionRateDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteConversionRates
    conversionRatesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // conversionRatesUpdateState
    conversionRatesStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
